import type {
  IReportColumn,
  ReportRowType,
} from '~/presentation/reports/common/Visualization/types';
import type { OrderByFields, ReportColumnLayoutMap } from '../../types';

import { SummaryRow } from './SummaryRow';
import { forwardRef } from 'react';
import { Header } from './Header';

export interface IReportHeaderSummary {
  content?: string;
  hide?: boolean;
  previousContent?: string;
  showPrevious?: boolean;
}

interface WrapperHeaderProps {
  columns: IReportColumn[];
  dimensions: string[];
  row?: ReportRowType;
  columnLayoutMap: ReportColumnLayoutMap;
  activeColumn?: string;
  orderBy?: OrderByFields;
  summary?: IReportHeaderSummary;
  minWidth?: number;
  onChangeOrderBy?: (field: string) => void;
}

export const WrapperHeader = forwardRef<HTMLDivElement, WrapperHeaderProps>(
  (
    {
      columns,
      dimensions,
      row,
      columnLayoutMap,
      activeColumn,
      orderBy,
      summary,
      minWidth,
      onChangeOrderBy,
    },
    ref,
  ) => {
    return (
      <div className="GReportTable__StickyHeader" ref={ref}>
        <div style={{ minWidth }}>
          <Header
            columns={columns}
            columnLayoutMap={columnLayoutMap}
            activeColumn={activeColumn}
            orderBy={orderBy}
            showSummary={!summary?.hide && !!dimensions.length}
            onChangeOrderBy={onChangeOrderBy}
          />

          <SummaryRow
            columns={columns}
            row={row}
            dimensions={dimensions}
            summary={summary}
            columnLayoutMap={columnLayoutMap}
          />
        </div>
      </div>
    );
  },
);

WrapperHeader.displayName = 'WrapperHeader';
